var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBirthdayCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3630",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43193",
    "data-name": "Group 43193",
    transform: "translate(4223 -18009)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16048",
    "data-name": "Rectangle 16048",
    width: 16,
    height: 16,
    transform: "translate(-4223 18009)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3624",
    transform: "translate(-4222 18692.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3626",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3628",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3634",
    transform: "translate(1.53 9.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3636",
    d: "M0-173.965v-3.642",
    transform: "translate(0 177.608)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3638",
    transform: "translate(12.47 9.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3640",
    d: "M0,0V3.642",
    transform: "translate(0)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3642",
    transform: "translate(1.188 7.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3644",
    d: "M0-30.316v1.057a.616.616,0,0,0,.826.51l1.035-.307a3.7,3.7,0,0,1,2.089,0l.817.242a3.7,3.7,0,0,0,2.088,0l.817-.242a3.7,3.7,0,0,1,2.089,0l1.035.307a.616.616,0,0,0,.826-.51v-1.057a.69.69,0,0,0-.734-.635H.734A.69.69,0,0,0,0-30.316Z",
    transform: "translate(0 30.951)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3646",
    transform: "translate(0.41 13.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3648",
    d: "M0,0H13.18",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3650",
    transform: "translate(2.868 4.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3652",
    d: "M-79.077-159.888v-2.978a.369.369,0,0,0-.369-.369h-.918a.369.369,0,0,0-.369.369v2.978Z",
    transform: "translate(80.733 163.236)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3654",
    transform: "translate(3.696 3.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3656",
    d: "M0,0V.813",
    transform: "translate(0)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3658",
    transform: "translate(2.863 0.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3660",
    d: "M-79.6-85.081a.833.833,0,0,1-.833.834.833.833,0,0,1-.833-.834,6.48,6.48,0,0,1,.833-1.781A6.48,6.48,0,0,1-79.6-85.081Z",
    transform: "translate(81.262 86.862)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3662",
    transform: "translate(6.172 4.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3664",
    d: "M-79.076-159.888v-2.978a.369.369,0,0,0-.369-.369h-.918a.369.369,0,0,0-.369.369v2.978Z",
    transform: "translate(80.732 163.236)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3666",
    transform: "translate(7 3.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3668",
    d: "M0,0V.813",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3670",
    transform: "translate(6.167 0.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3672",
    d: "M-79.6-85.081a.833.833,0,0,1-.833.834.833.833,0,0,1-.833-.834,6.48,6.48,0,0,1,.833-1.781A6.48,6.48,0,0,1-79.6-85.081Z",
    transform: "translate(81.262 86.862)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3674",
    transform: "translate(9.476 4.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3676",
    d: "M-79.077-159.888v-2.978a.369.369,0,0,0-.369-.369h-.918a.369.369,0,0,0-.369.369v2.978Z",
    transform: "translate(80.733 163.236)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3678",
    transform: "translate(10.304 3.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3680",
    d: "M0,0V.813",
    transform: "translate(0)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3682",
    transform: "translate(9.471 0.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3684",
    d: "M-79.6-85.081a.833.833,0,0,1-.833.834.833.833,0,0,1-.833-.834,6.48,6.48,0,0,1,.833-1.781A6.48,6.48,0,0,1-79.6-85.081Z",
    transform: "translate(81.262 86.862)",
    fill: "none",
    stroke: "#b2b9c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCake);
export default __webpack_public_path__ + "static/media/birthday-cake.a4b873fb84a17ef0ccae8a8bdfdfa129.svg";
export { ForwardRef as ReactComponent };